export const SELECT = 'select'
export const RANGE = 'range'
